// Чистые помощники слоя орбиты одного спутника (раздел «Спутники»). Без MapLibre:
// сборка LineString-трека витка из точек пути и короткая подпись зоны приёма для
// карточки. Отрисовка линии/маркера и подключение слоёв — в SatellitesPage.tsx.

import { t } from '../i18n'

/** Точка трека витка (широта/долгота в градусах). */
export interface OrbitPathPoint {
  lat: number
  lon: number
}

const ANTIMERIDIAN_JUMP = 180

/** Путь витка → FeatureCollection из одной или нескольких LineString.
 *
 *  Трек рвём на антимеридиане: если долгота между соседними точками прыгает более
 *  чем на 180° (например 178° → −179°), спутник пересёк 180-й меридиан, а не
 *  промчался через всю карту — рисовать эту «перемычку» нельзя, иначе через весь
 *  мир протянется ложная полоса. В таком месте закрываем текущий сегмент и
 *  начинаем новый. Нефинитные точки (пропагация TLE не сошлась) пропускаем.
 *  Сегменты короче двух точек отбрасываем — валидная LineString требует ≥2. */
export function orbitTrackToGeoJSON(path: OrbitPathPoint[]): GeoJSON.FeatureCollection {
  const segments: [number, number][][] = []
  let current: [number, number][] = []
  let prevLon: number | null = null

  for (const p of path) {
    if (!Number.isFinite(p.lat) || !Number.isFinite(p.lon)) continue
    if (prevLon !== null && Math.abs(p.lon - prevLon) > ANTIMERIDIAN_JUMP) {
      if (current.length >= 2) segments.push(current)
      current = []
    }
    current.push([p.lon, p.lat])
    prevLon = p.lon
  }
  if (current.length >= 2) segments.push(current)

  return {
    type: 'FeatureCollection',
    features: segments.map(coords => ({
      type: 'Feature',
      geometry: { type: 'LineString', coordinates: coords },
      properties: {},
    })),
  }
}

/** Короткая подпись зоны приёма для карточки: «приём 120–3005 км».
 *  Внутренний край — «мёртвая зона» под спутником (dead-zone), внешний — след
 *  приёма (footprint). Округляем до километра — доли метра в подписи бессмысленны.
 *  (Кольца ПОВЕРХ карты — задел Фазы 5, здесь только текст.) */
export function coverageRingLabel(footprint_km: number, dead_zone_km: number): string {
  const inner = Math.round(dead_zone_km)
  const outer = Math.round(footprint_km)
  return t('satellites.coverageRing', { inner, outer })
}
